import {useEffect, useState} from 'react';
import {Col, Container, Row, Modal, Image, Nav, Button} from 'react-bootstrap';
import MainButton from '../../UI/main-button/MainButton';
import classes from './style/ShowUserProfile.module.css';
import logo from "../../images/Travelicons/2ad783ae6973961a6dc5eb3559ac2054.png"
import {
  deleteAccount,
  editProfile,
  getReferalCode,
  getUserData,
} from './Auth.service';
import Dropdown from 'react-bootstrap/Dropdown';
import {
  FaCamera,
  FaCheckCircle,
  FaCopy,
  FaPlusSquare,
  FaShare,
  FaShareAlt,
  FaSignOutAlt,
} from 'react-icons/fa';
import {Language} from './interface/ILanguages';
import {useAppDispatch, useAppSelector} from '../../hooks/hooks';
import {insertLanguages} from '../../store/LanguageSlice';
import {useNavigate} from 'react-router-dom';
import {colors} from '../../constants/colors';
import toast, {Toaster} from 'react-hot-toast';
import UserSessions from '../Sessions/UserSessions';
import PrivateSessionsList from '../Booking/PrivateSessionsList';
import ConsultantProfileCourses from '../Consultants/components/ConsultantProfileCourses';
import {getUserAvatar, isUserLoggedIn} from '../../auth/utiles';
import {NavLink} from 'react-router-dom';
import {setLoading} from '../../store/userSlice';
import UserSurveyList from '../Survey/UserSurveyList';
import UserCertificates from '../Courses/UserCertificates';
import MyCourses from '../Consultants/components/MyCourses';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import UserFamily from './UserFamily';
import UserTasks from './UserTasks';
import { MdOutlineSegment } from 'react-icons/md';
import { getUserCurrency } from '../../helpers/getUserCurrency';
import UserEvents from './UserEvents';
import { getDynamicLinkDomain } from '../../helpers/getDynamicLinkDomain';
import ShareIcon from '../../components/share-icon/ShareIcon';
import CustomRadio from '../../UI/custom-radio/CustomRadio';
import logoAvatar from "../../UI/male-avatar-portrait-of-a-young-man-with-glasses-illustration-of-male-character-in-modern-color-style-vector.jpg"
import color from '../../UI/color';
import logoutt from "../../UI/majesticons_logout.svg";
import deletee from "../../UI/icon-park_delete-five.svg";
const ShowUserProfile = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const allLanguages = useAppSelector(state => state.language.languages);
  const [disableInputs, setdisableInputs] = useState(true);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone ,setphone]=useState('');
  const [birth, setBirth] = useState('');
  const [gender, setGender] = useState(1);
  const [refCode, setRefCode] = useState('');
  const [avatar, setAvatar] = useState('');
  const [languageSelected, setLanguageSelected] = useState<Language[]>([]);
  const [imagePreview, setImagePreview] = useState();
  const [errors, setErrors] = useState<{[key: string]: string}>();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showLogoutModal,setShowLogoutModal]=useState(false);
  const [wallet, setWallet] = useState('');
  const userAvatar = getUserAvatar();
  const userCurrency = getUserCurrency()

  const queryParams = new URLSearchParams(window.location.search);
    

  const [defaultActiveTab, setDefaultActiveTab] = useState(queryParams.get('tab') ?? 'first' );
  

  const isLoggedIn = isUserLoggedIn();

  const id = localStorage.getItem('id');

  const ICON_SIZE = 20;

  const handleImageChange = (e: any) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = (e: any) => {
        setAvatar(e.target.result);
        setImagePreview(file);
      };

      reader.readAsDataURL(file);
    }
  };

  const options = [
    {value: 'chocolate', label: 'Chocolate'},
    {value: 'strawberry', label: 'Strawberry'},
    {value: 'vanilla', label: 'Vanilla'},
  ];

  const LangSelectedCheck = (i: number): boolean => {
    if (languageSelected.find(item => item.id == i)) return true;
    else return false;
  };
  useEffect(() => {

    dispatch(insertLanguages());
    getData(false);
    getRef();
  }, []);

  const getData = async (redirectPage = false) => {
    let result = await getUserData();
    console.log('result.response', result.response);
    if (result.response.status) {
      setName(result.response.user.username);
      setphone(result.response.user.phone);
      setEmail(result.response.user.email);
      setBirth(result.response.user.birth_date);
      setGender(result.response.user.gender);
      setAvatar(result.response.user.avatar);
      setLanguageSelected(result.response.user.languages);
      setWallet(result.response.user.wallet_balance);
      //change image profile in local storage after edit profile
      if (redirectPage) {
        localStorage.setItem('avatar', result.response.user.avatar);
        dispatch(setLoading(false));
      }
    }
  };

  const getRef = async () => {
    let result = await getReferalCode();
    if (result.response.status) {
      setRefCode(result.response.referer_code);
      createDynamicLink(result.response.referer_code)
    }
  };

  const handleCopyClick = () => {
    toast.success('copied');
    // Create a temporary input element to copy the value
    const tempInput = document.createElement('input');
    tempInput.value = url;
    document.body.appendChild(tempInput);

    // Select and copy the value
    tempInput.select();
    document.execCommand('copy');
    
    // Remove the temporary input
    document.body.removeChild(tempInput);
  };

  const logout = () => {
    localStorage.removeItem('Consid');
    localStorage.removeItem('stars');
    localStorage.removeItem('id');
    localStorage.removeItem('switch');
    localStorage.removeItem('phone');
    localStorage.removeItem('isCons');
    localStorage.removeItem('lang');
    localStorage.removeItem('name');
    localStorage.removeItem('logged');
    localStorage.removeItem('avatar');
    localStorage.removeItem('ratingStars');
    localStorage.removeItem('email');
    localStorage.removeItem('token');
    localStorage.removeItem('feedBack');
    if(localStorage.getItem('i18nextLng') ){
      localStorage.removeItem('i18nextLng');
    }
    localStorage.removeItem('distenationRoute');
    localStorage.removeItem('userRefCode');
    localStorage.removeItem('solveQuiz')
    
    
    
    window.location.replace('/');
  };

  const Apply = async () => {
    dispatch(setLoading(true));
    let error: {[key: string]: string} = {};
    let y = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    // let phoneCheck =
    //   /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    // if (
    //   phoneCheck.test(
    //     `${this.state.phone_code}${this.containZero(this.state.phone)}`
    //   ) == false &&
    //   this.state.phone != "" &&
    //   this.state.phone != null
    // )
    //   errors.phone = I18n.t("wrongphone");

    if (name == '') error.name = 'Name Invalid';
    if (phone =='') error.phone="Phone number Invalid"
    if (email == '') error.email = 'mailvalid';
    else if (y.test(email) == false) error.email = 'Wrong Email';
    if (languageSelected.length == 0) error.lan = 'Wrong Languages';

    setErrors(error);
    if (Object.keys(error).length === 0) {
      let data = new FormData();
      data.append('_method', 'put');
      data.append('username', name);
      data.append('birth_date', birth);
      data.append('email', email);
      data.append('gender', String(gender));
      data.append("phone", phone);
      // data.append("phone_code", `${phone_code}`);

      languageSelected.map((i, index) => {
        data.append(`language_id[${index}]`, String(i.id));
      });

      if (imagePreview) data.append('avatar', imagePreview);
      console.log('dataaa3dit', data);
      //   language_id.map((i,index)=>{
      //  data[`language_id[${index}]`]=i=='english'?1:2
      //  })
      // data.append('firebase_token', 'firebase_token');
      let result = await editProfile(data);
      if (result.response) {
        getData(true);
        dispatch(setLoading(true));
        setdisableInputs(true)
      }

      //

      // this.getUser(true);
    }
  };
  const deleteAccFN = async () => {
    let result = await deleteAccount();
    if (result.response) {
      localStorage.removeItem('logged');
      localStorage.removeItem('token');
      localStorage.removeItem('name');
      localStorage.removeItem('email');
      localStorage.removeItem('avatar');
      localStorage.removeItem('phone');
      localStorage.removeItem('isCons');

      navigate('/login', {replace: true});
    }
  };
  const handleSelect = (key: string | null) => {
    navigate({ search: `?tab=${key}` });
  };

  const toggleFilter = () => {
    document.getElementById('userProfileSideBar')?.classList.toggle('hidden-filter'); 
  }

  const hideSideBar = () => {
    document.getElementById('userProfileSideBar')?.classList.remove('hidden-filter'); 
  }

  const [url, setUrl] = useState('https://championsacademy.page.link');

  const createDynamicLink = async (code:any) => {
    const requestBody = {
      dynamicLinkInfo: {
        domainUriPrefix: 'https://championsacademy.page.link',
        link: `${getDynamicLinkDomain()}/?type=referralCode&model_id=${code}`,
        androidInfo: {
          androidPackageName: 'com.championsacademy',
        },
        iosInfo: {
          iosBundleId: 'org.Champions.app',
        },
      },
    };

    try {
      const response = await fetch(
        `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=AIzaSyBlnJ9M_bXXKck16qjoInYIRo0xFp5pPPU`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        },
      );

      const data = await response.json();
      console.log('dynamic link,', data);
      // return the short link
      setUrl(data.shortLink);
    } catch (error) {
      console.error('Error creating dynamic link: ', error);
      throw error;
    }
  };


  const handleParentClick = () => {
    // Find the element with the class 'shareDropdown'
    const shareDropdownElement = document.querySelector('.shareDropdownBtn');
    if (shareDropdownElement) {
      // Create a new click event
      const event = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
      });

      // Dispatch the event to simulate a click
      shareDropdownElement.dispatchEvent(event);
    }
  };

  

  return (
    <div className={`position-relative `}  style={{ backgroundColor:" rgb(234, 251, 252)"}}>
      <Toaster position="top-right" />
      <div
        className={`${classes.ConsultantPages} consultant-pages pt-5`}
        style={{background: '#f9f9f9'}}>
        <Container>
          <Tab.Container
          id="left-tabs-example"
          defaultActiveKey={defaultActiveTab}
          onSelect={(key: string | null) => handleSelect(key)}
          >
            <Row>
              {/**      */}
              <div className="data mb-5 ">
                      <div className="row">
  <div className="d-flex align-items-center justify-content-between w-100 ">
    {/* Profile Button with Underline */}
    <Col md={4}>
  <button
    className="pb-2 pb-md-0  border-0 bg-transparent d-flex flex-column justify-content-center align-items-center text-decoration-none w-100" 
    style={{color:"rgba(19, 178, 188, 1)"}}
    onClick={() => {/* Add your profile click handler */}}
  >
    Profile
    <div className='text-center d-flex justify-content-center align-items-center ' style={{ height: '2px', width: '100px', backgroundColor: 'rgba(19, 178, 188, 1)', marginTop: '5px' }}></div>
  </button>
 
</Col>


  



  {/* Logout Button */}
  <Col md={4} >
    <button
      type="button"
      className="w-100 pb-2 pb-md-0  border-0 bg-transparent text-black "
      onClick={() => setShowLogoutModal(true)} // Open the logout modal
    >
      Logout
    </button>
  </Col>

  {/* Logout Modal */}
  <Modal show={showLogoutModal} onHide={() => setShowLogoutModal(false)} centered>
    <Modal.Body className="text-center">
      <img src={logoutt} alt="Logo" style={{ maxWidth: '60px' }} />
      <h5 className="mt-4 fw-bold">Come Back Soon !</h5>
      <p>Are you sure you want to log out ?</p>
    </Modal.Body>
    <Modal.Footer>
      <Row className="w-100">
        <Col>
        <Button style={{ color: "rgba(19, 178, 188, 1)" ,backgroundColor:"white" ,border:"1px solid rgba(19, 178, 188, 1) ",padding:" 15px 40px",fontWeight: "600"}} className="btn btn-outline w-100 " onClick={logout}>
    Yes, I'm Sure
</Button>
        </Col>
        <Col>
          <MainButton
            text="Cancel"
            onClick={() => setShowLogoutModal(false)} // Close the modal
          />
        </Col>
      </Row>
    </Modal.Footer>
  </Modal>

  {/* Delete Account Button */}
   
    <Col md={4}>  <button
      type="button"
      className="p-0 border-0 bg-transparent  w-100  text-black  " // Full-width outline-danger style
      onClick={() => setShowDeleteModal(true)} // Trigger the delete modal
    >
      Delete Account
    </button></Col>
  
  </div>


  
</div>
                      </div>
              <Col sm={12} className='bg-white d-flex justify-content-center align-items-center w-100 mb-5 pb-5  ' style={{width:"300px"}}>
              
                <Tab.Content>
                  
                  <Tab.Pane eventKey="first">
                    
                    <Container className={classes.FormContainer}>
                 
                      
                      <Row className="d-flex justify-content-center p-4 w-100 ">
                        <Col xs={12}>
                          <div>
                            <h3
                            style={{color:color.secondred}}
                              className={`fontWeight-bold   ${classes.HeaderTitle} text-center mt-4`}>
                              Your Profile 
                            </h3>

                            

                            <div className="mt-5 avatar-uploader text-center">
                              <Image
                                src={
                                  avatar
                                    ? avatar
                                    : userAvatar == 'null'
                                    ? `${logoAvatar}`
                                    : userAvatar!
                                }
                                alt="Avatar Preview"
                                roundedCircle
                                width={150}
                                height={150}
                              />
                              <label
                                htmlFor="avatar-input"
                                style={{
                                  position: 'relative',
                                  width: 'fit-content',
                                  margin: 'auto',
                                  padding: '10px',
                                  display: 'block',
                                  color: '#fff',
                                  cursor: 'pointer',
                                }}>
                                {!disableInputs && (
                                  <div className="default-avatar">
                                    <div
                                      style={{
                                  
                                        padding: '7px 17px',
                                        borderRadius: '10px',
                                        border:" 1px solid #FA5456",
                                        display: 'flex',
                                      }}>
                                      <FaCamera color="#FA5456" size={23} />
                                      <p className='fw-bold' style={{margin: '0 5px',color:color.secondred}}>
                                        Change Picture
                                      </p>
                                    </div>
                                  </div>
                                )}
                              </label>
                              <input
                                type="file"
                                id="avatar-input"
                                accept="image/*"
                                onChange={handleImageChange}
                                style={{display: 'none'}}
                      
                              />
                            </div>

                            <Row style={{color:"rgba(165, 165, 165, 1)"}}>
                              <Col md={4} style={{color:"rgba(165, 165, 165, 1)"}}>
                                <div className="mt-3 mb-3  text-font-muted" >
                                  <label>Name</label>
                                  <input
                                    type="text"
                                    disabled={disableInputs}
                                    className={`form-control m-0 bg-white text-font-muted py-2  `}
                                    required
                                    value={name}
                                    onChange={e => setName(e.target.value)}
                                  />
                                  {errors?.name && (
                                    <p style={{color: colors.darkRed}}>
                                      {errors.name}
                                    </p>
                                  )}
                                </div>
                              </Col>

                              <Col md={4}>
                                <div className="mt-3 mb-3">
                                  <label>Email Address</label>
                                  <input
                                    type="email"
                                    disabled={true}
                                    className={`form-control m-0 bg-white  text-font-muted   py-2 `}
                                    required
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                  />
                                </div>
                              </Col>
                              <Col md={4}>
                                <div className="mt-3 mb-3">
                                  <label>Phone Number</label>
                                  <input
                                    type="tel"
                                      id="phoneNumber"
                                      disabled={disableInputs}
                                    className={`form-control m-0 bg-white  text-font-muted   py-2 `}
                                    required
                                    value={phone}
                                    onChange={e => setphone(e.target.value)}
                                  />
                                </div>
                              </Col>  

                                 
                              {/* <div className="mt-3 mb-3">
                                <label>Date Of Birth</label>
                                <input
                                  type="date"
                                  disabled={disableInputs}
                                  className={`form-control m-0 ${classes.FormInput}`}
                                  placeholder="DD-mm-yyyy"
                                  required
                                  value={birth}
                                  onChange={e => setBirth(e.target.value)}
                                />
                              </div> */}
                             

                                  
                                {/* <Col xs={{span: 12}} md={{span: 12}}>
                                <div className="mt-3 mb-3">
                                  <label className="mb-2">
                                    <span style={{color: 'red'}}>* </span>Gender
                                  </label>
                                  <div className='d-md-flex'>
                                    <div className='mb-1' >
                                      <CustomRadio
                                        text="Male"
                                        checked={gender == 1}
                                        onClick={() => setGender(1)}
                                        disabled={disableInputs}
                                        
                                      />
                                    </div>
                                    <div className='mb-1' >
                                      <CustomRadio
                                        text="Female"
                                        checked={gender == 2}
                                        onClick={() => setGender(2)}
                                        disabled={disableInputs}
                                      />
                                    </div>
                                    <div className='mb-1' >
                                      <CustomRadio
                                        text="Prefer not to disclose"
                                        checked={gender == 3}
                                        onClick={() => setGender(3)}
                                        disabled={disableInputs}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </Col> */}
 <Col xs={{ span: 12 }} md={{ span: 12 }}>
  <div className="mt-3 mb-3 ms-2">
    <label className="mb-2">
      Gender <span style={{ color: 'red' }}>* </span>
    </label>
    <div className="d-md-flex">
      <div className="mb-1 pe-3">
        <input 
          type="radio" 
          id="male" 
          name="gender" 
          value="1" 
          
          style={{ 
            border:"1px solid red",
            accentColor: 'red', // Make the radio button red
            transform: 'scale(1.5)', // Increase the size of the radio button
            marginRight: '8px', // Add spacing between the radio button and label
          }} 
          checked={gender === 1} 
          onChange={() => setGender(1)} 
          disabled={disableInputs} 
        />
        <label htmlFor="male" className="" >Male</label>
      </div>
      <div className="mb-1 pe-3 ">
        <input 
          type="radio" 
          id="female" 
          name="gender" 
          value="2" 
      
          style={{ 
            border:"1px solid red",
            accentColor: 'red', // Make the radio button red
            transform: 'scale(1.5)', // Increase the size of the radio button
            marginRight: '', // Add spacing between the radio button and label
          }} 
          checked={gender === 2} 
          onChange={() => setGender(2)} 
          disabled={disableInputs} 
        />
        <label htmlFor="female" className="ms-2" >Female</label>
      </div>
      {/* <div className="mb-1 pe-3">
        <input 
          type="radio" 
          id="prefer-not-to-disclose" 
          name="gender" 
          value="3" 
          style={{ 
            border:"1px solid red",
            accentColor: 'red', // Make the radio button red
            transform: 'scale(1.5)', // Increase the size of the radio button
            marginRight: '8px', // Add spacing between the radio button and label
          }} 
          checked={gender === 3} 
          onChange={() => setGender(3)} 
          disabled={disableInputs} 
        />
        <label htmlFor="prefer-not-to-disclose" className="ms-2" >Prefer not to disclose</label>
      </div> */}
    </div>
  </div>
</Col>          
<Col xs={12} md={6}>
    <div className="mt-3 mb-3 w-100">
      {/* Label */}
      <label className="mb-2">
        <span style={{ color: "red" }}>*</span> Select Spoken Languages:
      </label>

      {/* Dropdown Component */}
      <Dropdown autoClose="outside">
        <Dropdown.Toggle
          disabled={disableInputs}
          className="form-control m-0"
          style={{
            background: "#fff",
            border: "1px solid #ccc",
            padding: "10px",
            textAlign: "left",
            width: "100%",
          }}
        >
          {languageSelected.length > 0 ? (
            languageSelected.map((lang) => lang.name).join(", ")
          ) : (
            <span style={{ color: "#aaa" }}>Select languages...</span>
          )}
        </Dropdown.Toggle>

        {/* Dropdown Menu with Scroll */}
        <Dropdown.Menu
          style={{
            maxHeight: "200px", // Adds a scrollbar if languages exceed this height
            overflowY: "auto",
            width: "100%",
          }}
        >
          {allLanguages.map((i) => (
            <Dropdown.Item
              key={i.id}
              onClick={() => {
                if (LangSelectedCheck(i.id)) {
                  setLanguageSelected(languageSelected.filter((items) => items.id !== i.id));
                } else {
                  setLanguageSelected([...languageSelected, i]);
                }
              }}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px",
                background: LangSelectedCheck(i.id) ? "rgba(19, 178, 188, 0.2)" : "white",
              }}
            >
              <span>{i.name}</span>
              {LangSelectedCheck(i.id) && (
                <span style={{ color: "rgba(19, 178, 188, 1)", fontWeight: "bold" }}>✔</span>
              )}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>

      {/* Selected Languages Display */}
      <div className="d-flex flex-wrap mt-2">
        {languageSelected.map((i) => (
          <div
            key={i.id}
            style={{
              display: "flex",
              alignItems: "center",
              borderRadius: "10px",
              padding: "8px 12px",
              margin: "5px",
              background: "rgba(19, 178, 188, 1)",
              color: "white",
              cursor: "pointer",
            }}
          >
            <span>{i.name}</span>
            <span
              onClick={() => {
                if (!disableInputs) {
                  setLanguageSelected(languageSelected.filter((items) => items.id !== i.id));
                }
              }}
              style={{
                marginLeft: "10px",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              ✖
            </span>
          </div>
        ))}
      </div>

      {/* Error Message */}
      {errors?.lan && <p style={{ color: "red", marginTop: "5px" }}>{errors.lan}</p>}
    </div>
    </Col>    


                              {/* <div className="mt-3 mb-3">
                                <label>Referral Link</label>
                                <div className="d-flex align-items-center" >
                                  <div className={`${classes.RefCode} d-flex align-items-center flex-grow-1 bg-white`} onClick={handleCopyClick}>
                                    <img src="/copy-ico.svg" alt="img" width={'25'} />
                                    <span style={{ marginLeft : '10px' }}>Copy Link</span>
                                  </div>
                                  <div className={`${classes.RefCode} d-flex flex-grow-1 bg-white`}
                                  onClick={handleParentClick}
                                  >
                                    <ShareIcon url={url} hasInvite={true} hasIcon={true} />
                                    <span>Share Link</span>
                                  </div>
                                  
                                  <input
                                    type="text"
                                    className={`form-control m-0 ${classes.FormInput}`}
                                    value={refCode}
                                    disabled={true}
                                    required
                                  />
                                  <img
                                    src="/icons/copy.png"
                                    width={30}
                                    className="m-1"
                                    style={{cursor: 'pointer'}}
                                    onClick={handleCopyClick}
                                  />
                                 
                                </div>
                              </div> */}



                            </Row>

                            <div
                              className="mt-4 mb-2"
                              onClick={() => {
                                disableInputs
                                  ? setdisableInputs(false)
                                  : Apply();
                              }}>

                              <MainButton
                                text={disableInputs ? 'Edit Profile' : 'Confirm'}
                              />
                            </div>
                            {/* <div className="mt-4 mb-2">
  <button
    type="button" // Correct type for a button
    className="btn  btn-outline-danger w-100 " // Add Bootstrap or custom classes for styling
    onClick={() => setShowDeleteModal(true)} // Trigger the delete modal
  >
    logout
  </button>
</div> */}

 {/* <div className="mt-4 mb-2">
  <button
    type="button" // Correct type for a button
    className="btn  btn-outline-danger w-100 " // Add Bootstrap or custom classes for styling
    onClick={() => setShowDeleteModal(true)} // Trigger the delete modal
  >
    Delete Account
  </button>
</div> */}

                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </Tab.Pane>
                  <Tab.Pane eventKey="family">
                    <h3 className="mb-4">My Family</h3>
                    <UserFamily />
                  </Tab.Pane>
                  
                  
                  <Tab.Pane eventKey="tasks">
                    <h3 className="mb-4">My Tasks</h3>
                    <UserTasks />
                  </Tab.Pane>
                  
                  
                  <Tab.Pane eventKey="sessions">
                    <h3 className="mb-4">My Sessions</h3>
                    <UserSessions />
                  </Tab.Pane>

                  <Tab.Pane eventKey="events">
                    <h3 className="mb-4">My Events</h3>
                    <UserEvents />
                  </Tab.Pane>

                  <Tab.Pane eventKey="requests">
                    <h3>My Requests</h3>
                    <PrivateSessionsList isCons={0} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="questionnaires">
                    <h3>My Questionnaires</h3>
                    <UserSurveyList />
                  </Tab.Pane>
                  
                  <Tab.Pane eventKey="courses">
                    <h3 className="mb-4">Courses</h3> 
                    <MyCourses />
                   
                    
                  </Tab.Pane>

                  <Tab.Pane eventKey="certificaties">
                    <h3 className="mb-4">Certificates</h3> 
                    <UserCertificates />
                  </Tab.Pane>
                    
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </Container>
      </div>

      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered>
        <Modal.Header>
          <Modal.Title></Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="text-center">
            <img src={deletee} style={{maxWidth: '60px'}} />
            <h5 className="w-100 mt-4 fw-bolder">
            Delete Account !
            </h5>
            <span>Are you sure you want to delete account ?</span>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Row className="w-100">
            <Col>
            <Button style={{ color: "rgba(19, 178, 188, 1)" ,backgroundColor:"white" ,border:"1px solid rgba(19, 178, 188, 1) ",padding:" 15px 40px",fontWeight: "600"}} className="btn btn-outline w-100 " onClick={deleteAccFN}>
    Yes, I'm Sure
</Button>

            </Col>
            <Col>
              <MainButton
                text={'Cancel'}
                onClick={() => setShowDeleteModal(false)}
              />
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>


      {/* <Modal show={showLogoutModal} onHide={() => setShowLogoutModal(false)} centered>
        <Modal.Body className="text-center">
          <img src={logo} alt="Logo" style={{ maxWidth: '60px' }} />
          <h5 className="mt-4 fw-bold">Logout</h5>
          <p>Are you sure you want to logout?</p>
        </Modal.Body>
        <Modal.Footer>
          <Row className="w-100">
            <Col>
              <Button
                className="btn btn-outline w-100"
                style={{
                  color: "red",
                  backgroundColor: "white",
                  border: "1px solid red",
                  padding: "15px 40px",
                  fontWeight: "600",
                }}
                onClick={logout}
              >
                Yes, Logout
              </Button>
            </Col>
            <Col>
              <MainButton text="Cancel" onClick={() => setShowLogoutModal(false)} />
            </Col>
          </Row>
        </Modal.Footer>
      </Modal> */}
      
    </div>
  );
};

export default ShowUserProfile;
